module.exports = __webpack_public_path__ + "static/img/tit5.2ea8d3f9.png";